import { AdapterContext, setIdentity } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from './value.adapter';
import { Named, Owned } from '../base/named';
import { NamedArray } from '../base/namedarray';
import { Column } from '../dataset/column';
import { Dataset } from '../dataset/dataset';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';
import { ColumnType } from 'app/shared/utils/column-type.util';
import { IStructure } from './datasets/dataset.constant.adapter';

export function columnValueToResource(owner: Named, columns: NamedArray<Column>, adapterContext: AdapterContext): IStructure[] | undefined {
    const columnsValue = ValueAdapter.toResource(owner, Metamodel.modelOf(owner).attribute('columns'));
    if (columnsValue == null) {
        return undefined;
    }
    if (columnsValue.type !== 'Expression' && Array.isArray(columnsValue)) {
        if (columnsValue.length === 0) {
            if ((owner as Dataset).isV2) {
                return [];
            }
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (columnsValue as NamedArray<Column>).map((column) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const columnValue: IStructure = {
                name: column.name,
                type: column.columnType !== ColumnType.UnsupportedType ? column.columnType : undefined
            };
            if (column.description) {
                columnValue.description = column.description;
            }
            // compatible with dataflow, format are available for more types
            // if (columnWithDateRelatedType(column)) {
            if (column.extension.format) {
                columnValue.format = column.extension.format as string;
            }
            if (column.extension.culture) {
                columnValue.culture = column.extension.culture as string;
            }
            if (column.precision != null) {
                columnValue.precision = column.precision;
            }
            if (column.scale != null) {
                columnValue.scale = column.scale;
            }
            // }
            const identity = adapterContext.identityProvider.identity(column);
            if (adapterContext.writeIdentities) {
                columnValue.identity = identity;
            }
            return columnValue;
        });
    } else {
        return columnsValue;
    }
}

export function columnResourceToValue(owner: Named, columns: IStructure[] | undefined): NamedArray<Column> {
    const result: NamedArray<Column> = new NamedArray<Column>(owner);
    if (columns != null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((typeof columns === 'string' && isLogicAppExpression(columns)) || (columns as any).type === 'Expression') {
            ValueAdapter.toModel(owner, Metamodel.modelOf(owner).attribute('columns'), columns);
            return result;
        } else if (Array.isArray(columns)) {
            columns.forEach(
                (column) => {
                    const newColumn: Column = Owned.create<Column>(Metamodel.modelFor(Column), owner);
                    if (column) {
                        newColumn.name = column.name;
                        newColumn.columnType = column.type;
                        if (column.description) {
                            newColumn.description = column.description;
                        }
                        if (column.format) {
                            newColumn.extension.format = column.format;
                        }
                        if (column.culture) {
                            newColumn.extension.culture = column.culture;
                        }
                        if (column.precision != null) {
                            newColumn.precision = column.precision;
                        }
                        if (column.scale != null) {
                            newColumn.scale = column.scale;
                        }
                        if (column.identity) {
                            setIdentity(newColumn, column.identity);
                        }
                    } else {
                        throw new Error('Invalid column found in ' + owner.name);
                    }
                    result.push(newColumn);
                }
            );
            return result;
        } else {
            return columns;
        }
    }
    return result;
}
